import { useSyncExternalStore } from 'react';
import { Platform } from 'react-native';

const getWidth = () => typeof window === 'undefined' ? null : window.innerWidth;
const getServerWidth = () => null;
const subscribe = listener => {
  if (Platform.OS !== 'web' || typeof window === 'undefined') return () => {};
  window.addEventListener('resize', listener);
  return () => window.removeEventListener('resize', listener);
};

// RN Web measures visualViewport/clientWidth, which excludes classic
// scrollbars. Showing a pane can add/remove that scrollbar and cross the
// same breakpoint again. All responsive consumers must use the stable
// layout viewport (including its scrollbar) for horizontal breakpoints.
export default function useWebLayoutWidth() {
  return useSyncExternalStore(subscribe, getWidth, getServerWidth);
}
